export const PREFIX = {
  EDS: "Eds:",
};
